import {createQueryKeys} from "../../shared/query/query-keys";

export const supplierOfferKeys = createQueryKeys("supplierOffers");
export const supplierOfferMutationKeys = {
  createSupplierOffer: ["supplierOffers", "mutation", "create-supplier-offer"] as const,
  updateSupplierOffer: ["supplierOffers", "mutation", "update-supplier-offer"] as const,
  deleteSupplierOffer: ["supplierOffers", "mutation", "delete-supplier-offer"] as const,
  restoreSupplierOffer: ["supplierOffers", "mutation", "restore-supplier-offer"] as const,
};
